const my_profile = {
  viewMyClubSeacretProfile: "Voir mon profil ClubSeacret", // translated
  unverifiedEmail: "E-mail non vérifié", // translated
  viewMoreDetails: "Afficher plus de détails", // translated
  verifiedEmail: "E-mail vérifié", // translated
  createdFrom: "Créé à partir de", // translated
  createdTo: "Créé jusqu'à", // translated
  selectStatus: "Sélectionner le statut...", // translated
  searchByTitle: "Rechercher par titre...", // translated
};

export default my_profile;
